import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from '../firebaseConfig';
import { doc, onSnapshot } from "firebase/firestore"; // use onSnapshot!

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [appUserAccountNumber, setAppUserAccountNumber] = useState(null);
  const [appUserEmail, setAppUserEmail] = useState(null);
  const [appUserFirstName, setAppUserFirstName] = useState(null);
  const [appUserLastName, setAppUserLastName] = useState(null);
  const [appUserRole, setAppUserRole] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (user) {
        const userDocRef = doc(db, "appUsers", user.uid);

        const unsubscribeSnapshot = onSnapshot(userDocRef, (userDocSnap) => {
          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();

            setAppUserAccountNumber(userData.accountNumber);
            setAppUserEmail(userData.email);
            setAppUserFirstName(userData.firstName);
            setAppUserLastName(userData.lastName);
            setAppUserRole(userData.role);
          }
          setLoading(false);
        }, (error) => {
          console.error('Error listening to user data:', error);
          setLoading(false);
        });

        // Important: unsubscribe snapshot when unmounting or auth state changes
        return unsubscribeSnapshot;
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribeAuth(); // cleanup auth listener
  }, []);

  return (
    <UserContext.Provider value={{ 
      appUserAccountNumber, 
      appUserEmail, 
      appUserFirstName, 
      appUserLastName, 
      appUserRole, 
      loading 
    }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
